module.exports = __webpack_public_path__ + "static/media/small-screen02.3bfb6e7f.png";